<template>
	<main class="main-content">
		<div class="right">
			<div class="right-inner">
				<div v-if="$route.name=='Chat'" class="chat-box">
					<div v-if="!allMessages" class="h-100 d-flex justify-content-center align-items-center">
						<b-spinner>
						</b-spinner>
					</div>
					<div v-else-if="hashMissing" class="text-center">
						<h1 class="title">Decryption key is missing</h1>
						<img src="../assets/images/ducks/no-message.gif" alt="">
					</div>
					<div v-else class="">
						<div class="wrap-head">
							<h2 class="title">
								Encrypted Chat Room
							</h2>
							<button class="share-link" @click.prevent="openShareLink()">
								<div class="icon">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M15 6.66663C16.3807 6.66663 17.5 5.54734 17.5 4.16663C17.5 2.78591 16.3807 1.66663 15 1.66663C13.6193 1.66663 12.5 2.78591 12.5 4.16663C12.5 5.54734 13.6193 6.66663 15 6.66663Z"
											stroke="#63BAAB" stroke-width="2" stroke-linecap="round"
											stroke-linejoin="round"/>
										<path
											d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z"
											stroke="#63BAAB" stroke-width="2" stroke-linecap="round"
											stroke-linejoin="round"/>
										<path
											d="M15 18.3334C16.3807 18.3334 17.5 17.2141 17.5 15.8334C17.5 14.4527 16.3807 13.3334 15 13.3334C13.6193 13.3334 12.5 14.4527 12.5 15.8334C12.5 17.2141 13.6193 18.3334 15 18.3334Z"
											stroke="#63BAAB" stroke-width="2" stroke-linecap="round"
											stroke-linejoin="round"/>
										<path d="M7.1582 11.2583L12.8499 14.575" stroke="#63BAAB" stroke-width="2"
											  stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M12.8415 5.42505L7.1582 8.74172" stroke="#63BAAB" stroke-width="2"
											  stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
								<div class="text">Share Link</div>
							</button>
						</div>

						<div class="form-group mb-3">
							<input
								v-model="author"
								placeholder="Type your name"
								class="author-input form-control"
								type="text"
							>
						</div>
						<div class="chat-messages" ref="chat_messages">
							<div class="mb-3 d-flex odd-message"
								 v-for="(item, index) in allMessages">
								<div v-if="item.text == 'error'" class="item">
									<div class="text">Wrong decryption key for this message</div>
									<div class="author">{{ item.author }}</div>
								</div>
								<div v-else class="item">
									<div class="text">{{ item.text }}</div>
									<div class="author">{{ item.author }}</div>
									<div class="author">{{ item.country }}</div>
									<div class="author">{{ item.masked_ip }}</div>
								</div>
							</div>
							<div v-if="no_messages" class="no-messages">No messages yet</div>
						</div>
						<form>
							<div class="d-flex wrap-submit">
								<input required v-model="message" class="form-control"
									  placeholder="Type your message..."/>
										<button :disabled="!message" @click.prevent="sendMessage() "
										class="btn btn-send-msg">
									<div class="">
										Send
									</div>
									<svg width="14" height="12" viewBox="0 0 14 12" fill="none"
										 xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_1160_366)">
											<path fill-rule="evenodd" clip-rule="evenodd"
												  d="M0.289655 11.952L13.8552 6.19202C14.0483 6.09602 14.0483 5.85602 13.8552 5.80802L0.289655 2.49986e-05C0.144828 -0.047975 0 0.048025 0 0.240025L0.289655 4.56002C0.337931 4.65602 0.386207 4.75202 0.482759 4.75202L6.08276 5.80802C6.27586 5.85602 6.27586 6.14402 6.08276 6.19202L0.482759 7.20002C0.386207 7.24802 0.337931 7.29602 0.337931 7.39202L0 11.76C0 11.904 0.144828 12 0.289655 11.952Z"
												  fill="white"/>
										</g>
										<defs>
											<clipPath id="clip0_1160_366">
												<rect width="14" height="12" fill="white"/>
											</clipPath>
										</defs>
									</svg>
								</button>
							</div>
						</form>
					</div>
				</div>
				<div v-else class="encrypted-msg">
					<div class="position-relative">
						<h1 v-if="activeView === VIEW.HOME" class="encrypting-message-title">What do you want to send?</h1>
						<h1 v-if="activeView === VIEW.UPLOAD" class="encrypting-message-title">Your secret file</h1>
						<div
							v-if="logged_in && userData.msgs_left === 0"
							class="note out-of-msg"
						>
							<div class="text-center">
								<img src="../assets/images/info.svg">
							</div>
							<p class="you-out-of-messages">
								You’ve reached your daily message limit. Upgrade your plan to send additional
								messages or try again in 24 hrs
							</p>
							<Button
								variant="lg"
								@onClick="$bvModal.show('modal-upgrade-plan')"
								text="Upgrade my Plan"
							/>
						</div>
						
						<div v-if="activeView === VIEW.HOME">
							<button class="btn btn-default" @click.prevent="activeView = VIEW.UPLOAD">
								<svg width="28" height="28" viewBox="0 0 28 28" fill="#ffffff"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_1160_260)">
										<path
											d="M24.3922 1.81653C26.3247 3.74897 26.3527 6.86467 24.4763 8.83141L24.3922 8.91743L12.9095 20.4002C11.701 21.6087 9.74174 21.6087 8.53329 20.4002C7.34765 19.2146 7.32528 17.3062 8.46618 16.0932L8.53329 16.024L17.6806 6.87674L19.332 8.52818L10.1847 17.6755C9.88834 17.9719 9.88834 18.4524 10.1847 18.7488C10.4676 19.0317 10.9183 19.0445 11.2165 18.7874L11.258 18.7488L22.7408 7.26599C23.7896 6.2172 23.7896 4.51676 22.7408 3.46797C21.7139 2.44102 20.0621 2.41963 19.0092 3.40378L18.9428 3.46797L7.46 14.9508C5.65879 16.752 5.65879 19.6723 7.46 21.4735C9.2335 23.247 12.092 23.2743 13.8988 21.5554L13.9828 21.4735L23.1301 12.3262L24.7815 13.9776L15.6342 23.1249C12.9209 25.8382 8.52183 25.8382 5.80856 23.1249C3.12578 20.4422 3.09563 16.1112 5.71813 13.3914L5.80856 13.2993L17.2913 1.81653C19.2522 -0.144328 22.4314 -0.144328 24.3922 1.81653Z"
											fill="#ffffff"/>
									</g>
								</svg>
								File
							</button>

							<button class="btn btn-green" @click.prevent="activeView = VIEW.MESSAGE">
								<img src="./../assets/images/message.svg">
								Message
							</button>
						</div>

						<div
							v-if="validFileSize"
							class="alert alert-warning"
						>
							{{ validFileMsg }}
							<button
								@click="objFile = null; hideDropzone = !hideDropzone; validFileSize = false"
								class="remove-file d-inline-block"
							>X</button>
						</div>

						<div
							v-else-if="objFile && objFile.name && activeView !== VIEW.ENCRYPT"
							class="uploaded-file-name mb-3 d-flex justify-content-center align-items-center gap-2"
						>
							<div class="d-inline-block">{{ objFile.name }}</div>
							<button
								@click="objFile = null; hideDropzone = !hideDropzone"
								class="remove-file d-inline-block"
							>X</button>
						</div>
						
						<div v-if="activeView === VIEW.UPLOAD">
							<vue-dropzone
								ref="dropzone1"
								id="drop1"
								:options="dropOptions"
								:include-styling="false"
								:use-custom-slot="true"
								@vdropzone-file-added="selectfile"

								:class="{'none': hideDropzone}"
							>
								<button
									@click.prevent="selectfile"
									class="btn btn-encrypt-file"
								>
									<svg width="28" height="28" viewBox="0 0 28 28" fill="rgb(108, 108, 116);" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_1160_260)">
											<path
												d="M24.3922 1.81653C26.3247 3.74897 26.3527 6.86467 24.4763 8.83141L24.3922 8.91743L12.9095 20.4002C11.701 21.6087 9.74174 21.6087 8.53329 20.4002C7.34765 19.2146 7.32528 17.3062 8.46618 16.0932L8.53329 16.024L17.6806 6.87674L19.332 8.52818L10.1847 17.6755C9.88834 17.9719 9.88834 18.4524 10.1847 18.7488C10.4676 19.0317 10.9183 19.0445 11.2165 18.7874L11.258 18.7488L22.7408 7.26599C23.7896 6.2172 23.7896 4.51676 22.7408 3.46797C21.7139 2.44102 20.0621 2.41963 19.0092 3.40378L18.9428 3.46797L7.46 14.9508C5.65879 16.752 5.65879 19.6723 7.46 21.4735C9.2335 23.247 12.092 23.2743 13.8988 21.5554L13.9828 21.4735L23.1301 12.3262L24.7815 13.9776L15.6342 23.1249C12.9209 25.8382 8.52183 25.8382 5.80856 23.1249C3.12578 20.4422 3.09563 16.1112 5.71813 13.3914L5.80856 13.2993L17.2913 1.81653C19.2522 -0.144328 22.4314 -0.144328 24.3922 1.81653Z"
												fill="#ffffff"
											/>
										</g>
									</svg>

									Upload
								</button>
							</vue-dropzone>
						</div>

						<div v-if="activeView === VIEW.MESSAGE">
							<h1 class="encrypting-message-title">Your secret message</h1>

							<textarea
								class="form-control message-textarea "
								v-model="msg"
								name=""
								id=""
								cols="30"
								rows="10"
								ref="msg"
								placeholder="Type your message or attach a file here..."
							></textarea>
							
						</div>

						<div v-if="activeView === VIEW.UPLOAD || activeView === VIEW.MESSAGE">
							<div class="radio-btns-title">Auto delete this message in:</div>
							<div class="wrap-radio-btn">
								<div
									v-for="item in expiryDateOptions"
									:key="item.id"
									class="form-check radio-btn"
								>
									<input class="form-check-input" type="radio" name="exampleRadios"
										:id="`${item.title}`"
										:value="`${item.value}`"
										v-model="checkedExpireDate"
									>
									<label
										class="form-check-label"
										:for="`${item.title}`"
									>1 {{ item.title }}</label>
								</div>
							</div>
							<button @click.prevent="sendMessageData()"
								:disabled="(!msg && !objFile) || (!msg && (objFile && !objFile.name)) || (objFile && validFileSize) || btnClicked"
								type="submit"
								class="btn"
								:class="{ 'btn-green': VIEW.MESSAGE, 'btn-default': VIEW.UPLOAD }"
							>
								<span v-if="activeView === VIEW.MESSAGE">Enscrypt Message</span>
								<span v-if="activeView === VIEW.UPLOAD">Enscrypt File</span>
							</button>
						</div>
					</div>
				</div>

				<div v-if="activeView === VIEW.ENCRYPT">
					<div
						class="encrypting-message"
						:class="{'no-left-side' : userData.plan === 'corporate' || !url_copied}"
					>
						<h2
							v-if="encrypting"
							class="encrypting-message-title"
						>{{encrypting_message}}</h2>

						<h2
							v-else-if="fileNotEncrypted"
							class="encrypting-message-title"
						>Error during file encryption</h2>

						<h2 v-else class="encrypting-message-title">Here you go!</h2>

						<div v-if="!encrypting && !fileNotEncrypted">
							<div class="form-group position-relative">
								<textarea
									class="message-url-input form-control mb-0"
									cols="30"
									rows="10"
									ref="input"
									v-model="msgUrl"
								></textarea>
								<div class="message-copied">
									<div
										v-show="show_copied_msg"
										class="text"
									>Copied</div>
								</div>
							</div>
							<div class="input-group-append mb-3">
								<Button
									full-width="true"
									variant="xl"
									text="Copy"
									@onClick="copyEncryptedMessageUrl('input')"
								/>
							</div>
						</div>
	
						<div
							v-if="objFile && objFile.name && encrypting"
							class="file-loading-bar mb-3"
						>
							<div class="loading-bar-text">{{Math.floor((currentChunck+1)*100/totalChunkCount)}}%</div>
							<div class="position-relative">
								<div class="loading-bar" :style="`width:${loadingBar}%`"></div>
								<div class="loading-bar-border"></div>
							</div>
						</div>
	
						<div v-if="!encrypting" class="position-relative">
							<div v-if="logged_in">
								<div class="optional-text">Optional:</div>
								<div class="position-relative mb-3">
									<input @input="editMessageMemo()"
										v-model="msgInfo.note"
										ref="memo_in_encrypted_message"
										type="text"
										class="form-control note mb-0 optional"
										placeholder="Name"
									>
									<div v-if="memo_saved" class="memo-saved">
										<img src="../assets/images/check_small.svg" alt="">
									</div>
								</div>
								<div class="form-group mb-3">
									<div class="d-flex align-items-center gap-2">
										<div class="position-relative flex-grow-1">
											<v-select
												:options="allCountries"
												@input="editMessage()"
												v-model="msgInfo.alert_when_opened_not_in"
												:disabled="userData.plan !== 'pro'"
												:class="['message-modal-custom-v-select', {'message-info' : userData.plan !== 'pro'}]"
												label="name"
												placeholder="Allow Opening In"
											></v-select>
											<div @click.prevent="payPro" v-if="userData.plan !== 'pro'" class="limit-access-to"/>
											<div
												v-if="userData.plan !== 'pro'"
												@click.prevent="payPro"
												class="is-pro"
											>Pro</div>
											<!-- <div class="">
												<div class="btn" @click="show_tooltip = !show_tooltip">
													<img width="27" height="27" src="../assets/images/info.svg" alt="">
												</div>
											</div> -->
										</div>
									</div>
									<div v-if="show_tooltip" class="custom-tooltip">
										Make sure the message you sent gets opened only within the country of the
										intended recipient.
									</div>
								</div>

								<!-- <div class="pro-btn">


								</div> -->
							</div>
						</div>
					</div>

					<b-modal id="modal-encrypted"
						size="xl"
						hide-footer
						hide-header
					>
						<transition name="slide-right">
							<div
								v-if="url_copied && userData.plan !== 'corporate'"
								tabindex="-1"
								class="left-side-content benefits"
							>
								<div v-if="!logged_in">
									<h3 class="encrypting-message-title">Why Join?</h3>
									<ul class="list">
										<li class="item">Track Messages and alerted when opened</li>
										<li class="item">10 messages daily limit with 10MB file limit</li>
										<li class="item">No credit card required</li>
									</ul>
									<Button
										class="btn-green"
										text="Sign up for free"
										fullWidth="true"
										variant="xl"
										@onClick="$bvModal.show('modal-sign-up')"
									/>
								</div>
								<div v-else-if="logged_in && userData.plan === 'free'">
									<h3 class="encrypting-message-title">Why Duckist Pro?</h3>
									<ul class="list">
										<li class="item">Increase file upload capacity to 100 MB</li>
										<li class="item">Increase daily message limit to 100 messages</li>
										<li class="item">Limit access location
											<div class="d-inline-block ml-2" id="popover-target-1">
												<img width="27" height="27" src="../assets/images/info.svg" alt="">
											</div>
											<b-popover target="popover-target-1" triggers="hover click" placement="top">
												Make sure the message you sent gets opened only within the country of the intended
												recipient.
											</b-popover>
										</li>
										<li class="item">Just $9.95/month for your peace of mind</li>
									</ul>
									<Button 
										class="btn-green"
										text="Start for just $9"
										fullWidth="true"
										variant="xl" @onClick="payPro"
									/>
								</div>
								<div v-else-if="logged_in && userData.plan === 'pro'">
									<h3 class="encrypting-message-title">Why Duckist Corporate?</h3>
									<ul class="list">
										<li class="item">Need extra layer of security?</li>
										<li class="item">Impossible number of teammates, clients and freelancers?</li>
										<li class="item">Find out if our corporate, self-hosted plan is right for you</li>
									</ul>
									<Button
										text="Book a consultation"
										class="btn-green"
										fullWidth="true"
										variant="xl"
										@onClick="$bvModal.show('modal-feedback')"
									/>
								</div>
								<button
									@click.prevent="closeModalEncrypted()"
									class="btn close"
								>No, thanks</button>
							</div>
						</transition>
					</b-modal>
				</div>

				<div v-if="activeView === VIEW.DECRYPTED" class="decrypted-msg">
					<div v-if="loading" class="loader">
						<div class="count-down-header">
							<h3 class="encrypting-message-title">Your file will appear in</h3>
						</div>
						<div class="loader-wrap">
							<b-spinner class="loader"></b-spinner>
						</div>

						<div class="text-center">
							<button
								@click.prevent="countDown = 0"
								class="btn btn-default"
							>Show Right Away</button>
						</div>
					</div>
					<div v-else-if="countDown !== 0">
						<div class="count-down-header">
							<h3 v-if="filehandle" class="encrypting-message-title">
								Your file will appear in
							</h3>
							<h3 v-else class="encrypting-message-title">
								Your message will appear in
							</h3>
						</div>

						<div class="count-down">{{ countDown }}</div>
						<div class="text-center">
							<button
								@click.prevent="countDown = 0"
								class="btn btn-default"
							>Show Right Away</button>
						</div>
					</div>
					<div v-else-if="decryptedMessage || filehandle" class="show-message">
						<div v-if="decryptedMessage">
							<h3 class="encrypting-message-title">Your secret message</h3>
							<div class="note">
								<div class="icon">
									<img src="../assets/images/u_info-circle.svg" alt="">
								</div>
								<div class="text">
									<b>Note:</b> Duckist link self destruct and you can only use it once. So, make sure to
									copy it.
								</div>
							</div>
							<textarea
								class="form-control decrypted-textarea"
								v-model="decryptedMessage"
								name=""
								id=""
								cols="30"
								rows="10"
								ref="message"
							></textarea>
							<Button variant="lg" fullWidth="true" text="Copy" @onClick="copy('message')"/>
						</div>
						<div v-if="!!filePath">
							<h3 class="encrypting-message-title">Your secret file:</h3>
		
							<div class="note">
								<div class="icon">
									<img src="../assets/images/u_info-circle.svg" alt="">
								</div>
								<div class="text">
									<b>Note:</b> Duckist link self destruct and you can only use it once. So, make sure to
									copy it.
								</div>
							</div>
		
							<button :disabled="fileDownloaded" class="btn btn-default" @click.prevent="downloadFile()">
								<div class="file-download-status">
									{{fileDownloadStatus}}
								</div>
							</button>
						</div>
					</div>
					<div v-else class="show-error">
						<h2 class="encrypting-message-title">Already Visited</h2>
		
						<div class="note">
							<img class="icon" src="../assets/images/u_info-circle.svg" alt="">
		
							<div class="text">
								Sorry, this secret message has already been viewed.
								You can only view the contents of this link once.
							</div>
						</div>
		
						<button
							@click.prevent="activeView = VIEW.HOME"
							class="btn btn-default"
						>Ok</button>
					</div>
				</div>
			</div>
		</div>
		<div class="left">
			<div class="left-inner">
				<div v-if="logged_in" class="side-menu">
					<!-- <div class="wrap-btn-hamburger">
						<button @click.prevent="openSideMenu()" class="btn btn-hamburger">
							<i class="icon-hamburger"></i>
						</button>
					</div> -->
					<transition name="slide">
						<div
							v-if="showSideMenu"
							tabindex="0"
							@keydown.esc="closeDashboard()"
							ref="side_menu"
							class="menu-content"
						>
							<div class="container">
								<div class="wrap-navigation-content content">
									<div class="wrap">
										<h2
											v-if="contentType == 'inbox'"
											class="title"
										>Your message box</h2>
										<h2
											v-if="contentType == 'settings'"
											class="title mb-0"
										>Settings</h2>
										<div class="navigation">
											<!-- <div class="navigation-item close">
												<button class="btn btn-with-icon"
														@click="closeDashboard()">
													<i class="icon-close"></i>
												</button>
											</div> -->
											<div class="navigation-item message">
												<button @click.prevent="contentType = 'inbox'"
														:class="{'active':contentType == 'inbox'}"
														class="btn-with-icon">
													<i class="icon-envelope"></i>
													Inbox
												</button>
											</div>
											<div class="navigation-item settings">
												<button @click.prevent="contentType = 'settings'"
														:class="{'active':contentType == 'settings'}"
														class="btn-with-icon">
													<i class="icon-settings"></i>
													Settings
												</button>
											</div>
											<div class="navigation-item log-out">
												<button class="btn-with-icon yellow"
														@click.prevent="$bvModal.show('modal-confirm-logout')">
													<i class="icon-log-out"></i>
													Logout
												</button>
											</div>
										</div>
									</div>
									<div v-if="contentType == 'inbox'" class="">
										<div class="table-responsive">
											<table class="table">
												<thead>
												<tr>
													<th class="table-head" scope="col">Name</th>
													<th class="table-head" scope="col">Status</th>
													<th class="table-head" scope="col">Options</th>
													<th class="table-head" scope="col">Allow Opening In</th>
													<th class="table-head" scope="col">Logs</th>
													<th class="table-head" scope="col">Edit</th>
												</tr>
												</thead>
												<tbody>
												<tr v-for="(item, index) in userMessages" :key="item.public_id">
													<td class="note">
														<div class="text">{{ item.note }}</div>
													</td>
													<td>
														<div v-if="item.expired" class="status expired">
															expired
														</div>
														<div v-else-if="item.seen" class="status seen">
															seen
														</div>
														<div v-else-if="!item.seen" class="status unseen">
															unseen
														</div>
													</td>
													<td>
														<div v-if="!item.notify_me"
															 class="alert-if">None
														</div>
														<div v-else class="alert-if">
															Notify Me
														</div>
													</td>
													<td>
														<div v-if="!item.alert_when_opened_not_in" class="alert-if">
															<span v-if="userData.plan !== 'free'">None</span>
															<span @click.prevent="$bvModal.show('modal-upgrade-plan')"
																  v-if="userData.plan == 'free'"
																  class="is-pro">Pro</span>
														</div>
														<div v-else class="alert-if">
															{{ countryCodeToName(item.alert_when_opened_not_in) }}
														</div>
													</td>
													<td>
														<a href="#"
														   @click.prevent="openLogs(item.public_id)"
														   class="btn-open-actions">
															<span>View Logs</span>
														</a>
													</td>

													<td>
														<a href="#"
														   @click.prevent="editAlerts(item.public_id)"
														   class="btn-open-actions">
															<span>Edit</span>
															<i class="icon-edit"></i>
														</a>
													</td>
												</tr>
												<tr v-if="!userMessages.length">
													<td class="text-center text-white" colspan="5">
														You have no messages
													</td>
												</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div v-else-if="contentType == 'settings'" class="content-settings">
										<div class="account-details">
											<h3 class="title">Account details</h3>
											<div class="data">
												<div class="form-group">
													<label for="email">Email</label>
													<input v-model="userData.email" type="email"
														disabled
														class="form-control" id="email"
														placeholder="Email">
												</div>
												<div class="form-group">
													<label>Current Timezone</label>
													<v-select
														:options="allTimezones"
														label="label"
														class="custom-v-select"
														v-model="userData.timezone"
														placeholder="Select your timezone"
													></v-select>
												</div>
											</div>
										</div>
										<div class="plan-details">
											<h3 class="title">Plan details</h3>
											<div class="data">
												<div class="wrap-current-plan">
													<div
														:class="{'free': userData.plan=='free', 'pro': userData.plan=='pro', 'corporate': userData.plan=='corporate'}"
														class="current-plan mb-3 mb-lg-0">
														<i class="icon-eye icon"></i>
														<span v-if="userData.plan=='free'" class="text">Free</span>
														<span v-if="userData.plan=='pro'" class="text">Pro</span>
														<span v-if="userData.plan=='corporate'"
															  class="text">Corporate</span>
													</div>
													<button @click.prevent="$bvModal.show('modal-upgrade-plan')"
															class="btn btn-update-plan">
														Upgrade my Plan
													</button>
												</div>
												<p v-if="userData.plan=='free'" class="text">
													If you are a business owner or a resident of certain countries, you
													can obtain a VAT exemption. Please fill in your VAT number in the
													Stripe payment form.
												</p>
												<p v-else-if="userData.plan=='pro'" class="text">
													Thanks for upgrading your plan! <br>
													Enjoy all the additional features of your Duckist Pro
												</p>
											</div>
										</div>
										<!--
										<div class="personal-information">
											<h3 class="title">Personal Information</h3>
											<div class="data">
												<div class="form-group">
													<label>Business Name</label>
													<input v-model="userData.name" type="text" class="form-control"
														   placeholder="Business Name">
												</div>
												<div class="form-group">
													<label>Address</label>
													<input v-model="userData.address" type="text"
														   class="form-control"
														   placeholder="Address">
												</div>
												<div class="form-group">
													<label>TAX/VAT number</label>
													<input v-model="userData.tin" type="text" class="form-control"
														   placeholder="TAX/VAT number">
												</div>
												<div class="form-group">
													<label>Country</label>
													<v-select
														:options="allCountries"
														label="name"
														class="custom-v-select"
														v-model="userData.country"
														placeholder="Select your country"
													></v-select>
												</div>
												<div class="form-group">
													<label>City</label>
													<input v-model="userData.city" type="text" class="form-control"
														   placeholder="City">
												</div>
												<div class="form-group">
													<label>Zip Code</label>
													<input v-model="userData.zipcode" type="text"
														   class="form-control"
														   placeholder="Zip Code">
												</div>
											</div>
										</div>
										-->

										<div class="d-flex align-items-center flex-wrap mb-4">
											<button @click.prevent="saveUserData()" class="btn btn-save">Save
												changes
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition>
				</div>
				<ChatBenefits v-if="$route.name=='Chat'" :message_expire="message_expire"/>
				<Benefits v-else/>
			</div>
		</div>
		<!-- <div class="side-btns">
			<router-link v-if="$route.name=='Chat'" to="/" class="btn-open-side-btn">
				<svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M15.533 1.4165C13.638 1.4165 11.7402 1.83303 9.93904 2.57593C8.13625 3.2705 6.43068 4.38322 5.00623 5.72619C3.58566 6.97794 2.44843 8.55388 1.6412 10.2227C0.882859 11.8448 0.455078 13.6059 0.455078 15.4132C0.455078 17.4062 0.833969 19.3058 1.59231 21.0214C2.35343 22.7825 3.44121 24.3584 4.86567 25.703C6.19235 26.9553 7.8518 27.9741 9.70071 28.7159C11.4552 29.3643 13.3991 29.7347 15.533 29.7347C15.7713 29.7347 16.1013 29.7347 16.4808 29.6885C16.9085 29.6885 17.288 29.6424 17.6663 29.6424C17.9508 29.5962 18.3336 29.5962 18.6636 29.5495L19.4213 29.4572C22.0319 30.9403 24.7336 32.192 27.0564 33.9998V32.6552V32.5168V26.2124C27.7692 25.6107 28.3825 24.9161 28.9542 24.2199C29.5686 23.3864 30.1364 22.505 30.5648 21.5791C30.9925 20.6515 31.277 19.6311 31.5125 18.6124C31.702 17.592 31.8459 16.527 31.8459 15.4138C31.8459 13.5136 31.372 11.7063 30.5653 10.0375C29.7586 8.32254 28.527 6.79275 27.0075 5.49485C25.5403 4.19803 23.7369 3.17763 21.7441 2.48307C19.8486 1.78687 17.7608 1.4165 15.533 1.4165ZM10.9329 15.6451C10.9329 15.738 10.9329 15.8764 10.9329 15.9693C10.8868 16.0622 10.8868 16.1545 10.8379 16.249C10.7924 16.3418 10.7435 16.4342 10.6979 16.5265C10.6485 16.5726 10.5535 16.6655 10.5079 16.7117L10.459 16.7578H10.4135C10.364 16.8501 10.3185 16.8963 10.2235 16.943C10.1752 16.9892 10.0802 17.0359 9.98515 17.082C9.89071 17.082 9.79571 17.1282 9.70071 17.1749C9.56071 17.1749 9.4657 17.1749 9.36793 17.1749C9.22737 17.1749 9.13237 17.1749 9.03792 17.1749C8.94292 17.1287 8.84792 17.1287 8.75348 17.082C8.65848 17.0359 8.56348 16.9897 8.51514 16.943C8.42014 16.8968 8.32514 16.8045 8.23014 16.7578V16.7117C8.18514 16.6655 8.13569 16.5726 8.04069 16.5265C7.99514 16.4342 7.94569 16.3418 7.90014 16.249C7.85125 16.1545 7.85125 16.0622 7.80569 15.9693C7.80569 15.877 7.80569 15.738 7.80569 15.6451C7.80569 15.5522 7.80569 15.4138 7.80569 15.3214C7.85125 15.2286 7.85125 15.1363 7.90014 15.0434C7.94569 14.9505 7.99514 14.8582 8.04069 14.8121C8.09014 14.7197 8.13569 14.673 8.23014 14.6269V14.5802C8.32514 14.4857 8.42014 14.3934 8.51514 14.3472C8.56348 14.301 8.65848 14.2549 8.75348 14.2082C8.84792 14.2082 8.94292 14.162 9.03792 14.162C9.13237 14.1159 9.22737 14.1159 9.36793 14.1159C9.4657 14.1159 9.56071 14.1159 9.70071 14.162C9.79571 14.162 9.89071 14.2082 9.98515 14.2082C10.0802 14.2543 10.1752 14.3005 10.2235 14.3472C10.3185 14.3934 10.364 14.4395 10.4135 14.534H10.459L10.5079 14.5802C10.5535 14.6263 10.6485 14.7192 10.6979 14.8115C10.7435 14.8577 10.7924 14.95 10.8379 15.0429V15.089C10.8868 15.1352 10.8868 15.2742 10.9329 15.3671C10.9329 15.4599 10.9329 15.5522 10.9329 15.6451ZM17.3358 15.9693C17.3358 16.0622 17.2874 16.1545 17.2413 16.249C17.1924 16.4342 17.0513 16.6193 16.908 16.7584C16.8619 16.8045 16.7674 16.8968 16.673 16.9435C16.578 16.9897 16.5285 17.0364 16.4341 17.0826C16.3397 17.0826 16.1952 17.1287 16.1008 17.1754C16.0058 17.1754 15.9108 17.1754 15.7708 17.1754C15.6758 17.1754 15.5808 17.1754 15.4863 17.1754C15.3913 17.1293 15.2969 17.1293 15.2024 17.0826H15.153C15.1074 17.0364 15.0124 16.9902 14.918 16.9435C14.823 16.8974 14.7741 16.8051 14.6796 16.7584C14.5846 16.6655 14.5352 16.5732 14.4896 16.5265C14.4407 16.4342 14.3457 16.3418 14.3457 16.249C14.3002 16.1545 14.2513 16.0622 14.2513 15.9693C14.2513 15.877 14.2052 15.738 14.2052 15.6451C14.2052 15.5522 14.2513 15.4138 14.2513 15.3214C14.2513 15.2286 14.3002 15.1363 14.3457 15.0434C14.3457 14.9505 14.4407 14.8582 14.4896 14.8121C14.5352 14.7197 14.5846 14.673 14.6302 14.6269L14.6796 14.5807C14.7741 14.4862 14.823 14.3939 14.918 14.3477C15.0124 14.3016 15.1074 14.2554 15.153 14.2554L15.2024 14.2093C15.2969 14.2093 15.3913 14.1631 15.4863 14.1631C15.5808 14.1169 15.6758 14.1169 15.7708 14.1169C15.9108 14.1169 16.0058 14.1169 16.1008 14.1631C16.1952 14.1631 16.2902 14.2093 16.4341 14.2093V14.2554C16.5285 14.2554 16.578 14.3016 16.673 14.3477C16.7674 14.3939 16.813 14.4401 16.8619 14.5346H16.908V14.5807C17.003 14.6269 17.0513 14.7197 17.0974 14.8121C17.1463 14.8582 17.1924 14.9505 17.2413 15.0434V15.0896C17.2874 15.1357 17.3358 15.2747 17.3358 15.3676C17.3813 15.4599 17.3813 15.5528 17.3813 15.6451C17.3813 15.738 17.3813 15.8764 17.3358 15.9693ZM22.2203 14.1153C22.3608 14.1153 22.4553 14.1153 22.5503 14.1615C22.6453 14.1615 22.7397 14.2076 22.8341 14.2076L22.8836 14.2538C22.9291 14.2538 23.0236 14.3 23.1186 14.3461C23.168 14.3923 23.2625 14.4384 23.308 14.5329L23.3575 14.5791C23.403 14.6252 23.498 14.7181 23.5464 14.8104C23.5958 14.8566 23.6414 14.9489 23.6908 15.0418C23.7364 15.1346 23.7858 15.2269 23.7858 15.3198C23.7858 15.4121 23.8314 15.5512 23.8314 15.6435C23.8314 15.7363 23.7858 15.8748 23.7858 15.9677C23.7858 16.0605 23.7364 16.1529 23.6908 16.2474C23.6414 16.3402 23.5958 16.4325 23.5464 16.5249C23.498 16.571 23.403 16.6639 23.3575 16.7567C23.2625 16.8029 23.168 16.8952 23.1186 16.9419C23.0236 16.9881 22.9291 17.0348 22.8341 17.0809C22.7397 17.1271 22.6453 17.1271 22.5503 17.1738C22.4553 17.1738 22.3608 17.1738 22.2203 17.1738C22.1252 17.1738 22.0308 17.1738 21.9358 17.1738C21.8408 17.1276 21.6975 17.1276 21.6025 17.0809C21.5536 17.0348 21.4586 16.9886 21.3636 16.9419C21.2697 16.8958 21.2236 16.8496 21.1286 16.7567C21.0336 16.6639 20.9852 16.5716 20.9391 16.5249C20.8447 16.4325 20.7952 16.3402 20.7497 16.2474C20.7497 16.1529 20.7008 16.0605 20.7008 15.9677C20.6552 15.8754 20.6552 15.7363 20.6552 15.6435C20.6552 15.5506 20.6552 15.4121 20.7008 15.3198C20.7008 15.2269 20.7497 15.1346 20.7497 15.0418C20.7952 14.9489 20.8447 14.8566 20.9391 14.8104C20.9852 14.7181 21.0336 14.6252 21.1286 14.5791V14.5329C21.2236 14.4851 21.2697 14.3928 21.3636 14.3461C21.4586 14.3 21.5536 14.2538 21.6025 14.2071C21.6975 14.2071 21.7925 14.1609 21.9358 14.1609C22.0308 14.1153 22.1252 14.1153 22.2203 14.1153Z"
						fill="white"/>
				</svg>
				<span class="text">
						Secret message
					</span>
			</router-link>
			<button @click.prevent="$bvModal.show('modal-show-chat')" v-else class="btn-open-side-btn">
				<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M26.8942 12.444H25.1602V6.90201C25.1602 3.57001 22.4402 0.850006 19.1082 0.850006H14.8922C11.5602 0.850006 8.84016 3.57001 8.84016 6.90201V12.444H7.10616C5.33816 12.444 3.91016 13.872 3.91016 15.64V29.988C3.91016 31.756 5.33816 33.184 7.10616 33.184H26.9282C28.6962 33.184 30.1242 31.756 30.1242 29.988V15.64C30.0902 13.872 28.6622 12.444 26.8942 12.444ZM19.3462 27.404C19.4482 27.778 19.1422 28.152 18.7682 28.152H15.2322C14.8242 28.152 14.5522 27.778 14.6542 27.404L15.8442 22.848C14.8582 22.406 14.1782 21.42 14.1782 20.264C14.1782 18.7 15.4362 17.442 17.0002 17.442C18.5642 17.442 19.8222 18.7 19.8222 20.264C19.8222 21.42 19.1422 22.406 18.1562 22.848L19.3462 27.404ZM20.8082 12.444H13.1922V6.90201C13.1922 5.95001 13.9402 5.20201 14.8922 5.20201H19.1422C20.0942 5.20201 20.8422 5.95001 20.8422 6.90201V12.444H20.8082Z"
						fill="white"/>
				</svg>
				<span class="text">
						Create Chat Room
					</span>
			</button>
		</div> -->
		<Flash ref="show"/>
		<b-modal id="modal-edit-notification"
			hide-footer
			hide-header
			size="md"
			modal-class="modal-padding-around"
		>
			<a href="#" class="close-btn"
			   @click.prevent="$bvModal.hide('modal-edit-notification')"></a>
			<h2 class="title mb-3">
				Edit Message
			</h2>
			<p class="text-center mb-3">When would you like to be notified?</p>

			<div class="form-group wrap-input-modal mb-3">
				<input v-model="msgInfo.note" type="text" class="form-control note mb-0" placeholder="Name">
			</div>
			<div class="notifications-checkboxes mb-3">
				<div class="form-group">
					<div class="position-relative">
						<v-select
							:options="allCountries"
							label="name"
							class="custom-v-select advanced"
							v-model="msgInfo.alert_when_opened_not_in"
							placeholder="Allow Opening In"
						></v-select>
						<div @click.prevent="payPro" v-if="userData.plan !== 'pro'" class="limit-access-to" />
						<div v-if="userData.plan !== 'pro'" @click.prevent="payPro" class="is-pro">Pro</div>
					</div>
				</div>
			</div>
			<div class="wrap-btn text-center">
				<button @click.prevent="editMessageInDashboard()"
						class="btn-save-msg-changes">
					Save
				</button>
			</div>
		</b-modal>
		<b-modal id="modal-logs"
			class="modal"
			hide-footer
			hide-header
			size="md"
			modal-class="modal-padding-around"
		>
			<a href="#" class="close-btn" @click.prevent="$bvModal.hide('modal-logs')"></a>
			<h2 class="title">
				Logs
			</h2>
			<div v-if="!msgInfo.logs.length" class="item">This message has no logs</div>
			<div class="item" :class="item.level" v-else v-for="(item, index) in msgInfo.logs" :key="index">
				<div>
					<div class="log-item created">
						<div class="top-text">{{item.txt}}</div>
						<div class="d-flex gap-3 justify-content-between">
							<div class="bottom-text">{{item.country_name}} ({{item.ip}})</div>
							<div class="bottom-text">{{formatDate(item.created*1000)}}</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="modal-upgrade-plan"
			class="modal"
			hide-footer
			hide-header
			size="xl"
		>
			<a href="#" class="close-btn" @click.prevent="$bvModal.hide('modal-upgrade-plan')"></a>
			<h2 class="title">Upgrade Plan</h2>

			<div class="row">
				<div class="col-lg-6 col-xl-4 mb-3 mb-xl-0">
					<div class="plan-item">
						<div class="wrap-img">
							<img src="../assets/images/plan/free.svg" alt="">
						</div>
						<div class="title">Basic</div>
						<ul class="list">
							<li class="list-item">10 messages per day</li>
							<li class="list-item">5 MB file size limit</li>
							<li class="list-item">100 MB total storage</li>
							<li class="list-item">up to 10 alerts monthly</li>
						</ul>
						<div class="price">Free</div>
						<button v-if="userData.plan=='free' || userData.plan_ends==null"
								:class="{'active': userData.plan=='free' || userData.plan_ends==null}"
								class="btn btn-plan-submit">
							Current Plan
						</button>
						<button :disabled="userData.plan === 'pro' || userData.plan === 'corporate'" v-else class="btn btn-plan-submit">Free Plan</button>
					</div>
				</div>
				<div class="col-lg-6 col-xl-4 mb-3 mb-xl-0">
					<div class="plan-item">
						<div class="wrap-img">
							<img src="../assets/images/plan/pro.svg" alt="">
						</div>
						<div class="title">Duckist Pro</div>
						<ul class="list">
							<li class="list-item">100 messages per day</li>
							<li class="list-item">50 MB file size limit</li>
							<li class="list-item">1 GB total storage</li>
							<li class="list-item">up to 100 alerts monthly</li>
						</ul>
						<div class="price">$9.95<span>/month</span></div>
						<button @click.prevent="$bvModal.show('modal-feedback-cancel')"
								v-if="userData.plan=='pro' && !!userData.plan_ends" class="btn btn-plan-submit active">
							Cancel
						</button>
						<button v-else @click="payPro()" class="btn btn-plan-submit">
							Upgrade Plan
						</button>
					</div>
				</div>
				<div class="col-lg-6 col-xl-4 mb-3 mb-xl-0">
					<div class="plan-item">
						<div class="wrap-img">
							<img src="../assets/images/plan/corporate.svg" alt="">
						</div>
						<div class="title">Duckist Corporate</div>
						<ul class="list">
							<li class="list-item">On-Premise Hosting</li>
							<li class="list-item">Own Domain</li>
							<li class="list-item">Unlimited number of users</li>
							<li class="list-item">24/7 tech support</li>
						</ul>
						<button v-if="userData.plan=='corporate'"
								class="btn btn-plan-submit active"
								@click.prevent="$bvModal.show('modal-feedback-cancel')"
						>Cancel</button>
						<button v-else @click.prevent="$bvModal.show('modal-feedback')" class="btn btn-plan-submit">
							Contact Support
						</button>
					</div>
				</div>
			</div>
		</b-modal>
<!--// TODO remove??? -->
		<b-modal id="modal-payment"
			modal-class="modal-img-in-top"
			hide-footer
			hide-header
			size="md"
			@hide="paymentData = {}"
		>
			<div class="wrap-img">
				<img src="../assets/images/ducks/send.png" alt="">
			</div>
			<div v-if="afterGetFreeTrial" class="modal-content">
				<h2 class="title">Enjoy your Duckist Pro!</h2>
				<p class="text-center">
					If our service isn’t a good fit you’re free to cancel at any time.
					To do so <a class="contact-team-link" href="#"
								@click.prevent="$bvModal.show('modal-feedback-cancel')">contact support</a>
				</p>
			</div>
			<div v-else class="modal-content">
				<h2 class="title">Upgrade Plan</h2>
				<form @submit.prevent="upgradePlan()">
					<div class="form-group mb-3">
						<label class="form-label">Country</label>
						<v-select
							:options="allCountries"
							label="name"
							class="custom-v-select payment"
							v-model="userData.country"
							placeholder="Select country"
						></v-select>
					</div>
					<div class="form-group wrap-input-modal mb-3">
						<label class="form-label">Zip Code</label>
						<input v-model="userData.zipcode" type="text" class="form-control input-modal"
							placeholder="Zip Code">
					</div>
					<div class="form-group wrap-input-modal">
						<label class="form-label">Card Number</label>
						<input required v-mask="'#### #### #### ####'" @input="validCardNumber($event)"
							v-model="paymentData.credit_card_number" type="text" class="form-control input-modal"
							placeholder="1234 1234 1234 1234">
					</div>
					<div class="row">
						<div class="col-6">
							<div class="form-group wrap-input-modal">
								<label class="form-label">Expiry Date</label>
								<input required @input="validExpiryDate()" v-mask="'## / ####'"
									   v-model="paymentData.expire_date" type="text"
									   class="form-control input-modal"
									   placeholder="MM / YY">
							</div>
						</div>
						<div class="col-6">
							<div class="form-group wrap-input-modal">
								<label class="form-label">Security Code</label>
								<input @input="validSecurityCode()" required v-mask="'###'"
									   v-model="paymentData.security_code" type="text"
									   class="form-control input-modal"
									   placeholder="123">
							</div>
						</div>
					</div>
					<div class="">
						<input :disabled="!validCreditCard || !paymentData.expire_date || !paymentData.security_code"
							   type="submit" class="submit-modal" :value="creditCardMsg">
					</div>
				</form>
			</div>
		</b-modal>
		<b-modal id="modal-confirm"
			class="modal"
			hide-footer
			hide-header
			size="md"
			@shown="$refs.btn_yes.focus()"
		>
			<a href="#" class="close-btn" @click.prevent="$bvModal.hide('modal-confirm')"></a>
			<h1 class="title text-center">Confirm action</h1>
			<h5 class="text-center mb-3">
				Are you sure you want to close modal?
			</h5>
			<div class="btns">
				<button ref="btn_yes" @keydown.enter="closeModalEncrypted()" @click.prevent="closeModalEncrypted()"
						class="btn btn-yes">Yes
				</button>
				<button class="btn btn-no" @click.prevent="$bvModal.hide('modal-confirm')">No</button>
			</div>
		</b-modal>
		<b-modal id="modal-confirm-logout"
			class="modal"
			hide-footer
			hide-header
			size="md"
		>
			<a href="#" class="close-btn" @click.prevent="$bvModal.hide('modal-confirm-logout')"></a>
			<h1 class="title text-center">Confirm action</h1>
			<h5 class="text-center mb-3">
				Are you sure you want to log out?
			</h5>
			<div class="btns">
				<button @click.prevent="$bvModal.hide('modal-confirm-logout'), logOut()" class="btn btn-yes">Yes
				</button>
				<button class="btn btn-no" @click.prevent="$bvModal.hide('modal-confirm-logout')">No</button>
			</div>
		</b-modal>
		<b-modal id="modal-share-chat-link"
			class="modal modal-img-in-top"
			hide-footer
			hide-header
			size="md"
			modal-class="modal-img-in-top"
		>
			<div class="wrap-img">
				<img src="../assets/images/ducks/send.png" alt="">
			</div>

			<div class="content">
				<h2 class="title">Here you go!</h2>
				<p class="text">Chats are only accessible to whoever has the link</p>
				<div class="form-group">
					<input type="text" class="url-input form-control" ref="chat_url" v-model="chat_url">
					<div class="input-group-append text-center">
						<button class="btn copy-message-url" @click="copy('chat_url')">Copy</button>
					</div>
				</div>
			</div>
		</b-modal>
		<Feedback :id="'modal-feedback'"
				  :title="'Corporate Upgrade'"
				  :phone="'1234567'"
				  :text_placeholder="'What do you want to use corporate plan for?'"
				  api_title="Corporate Duckist Account"
		/>
		<Feedback :id="'modal-feedback-cancel'"
				  :top_img="'sad'"
				  :title="'Cancel subscription'"
				  :text_placeholder="'I want to cancel my subscription because...'"
				  api_title="Cancel"
		/>
		<ModalShowChat :id="'modal-show-chat'" :title="'Create Chat Room'"/>
	</main>
</template>

<script>
	import vSelect from "vue-select";
	import "vue-select/dist/vue-select.css";
	import timezones from 'timezones-list';
	import axios from "axios";
	import sjcl from "sjcl";
	import Benefits from "../components/Benefits";
	import ChatBenefits from "../components/ChatBenefits";
	import Flash from "../components/Flash";
	import Feedback from "../components/Feedback";
	import Button from "../components/Button";
	import ModalShowChat from "../components/ModalShowChat";
	import {api} from "../mixins/axios";
	import {eventBus} from '../main'
	import vue2Dropzone from 'vue2-dropzone'
	import 'vue2-dropzone/dist/vue2Dropzone.min.css'

	const countryList = require('country-list');
	const valid = require("card-validator");

	export default {
		name: "App",
		metaInfo: {
			meta: [
				{
					name: 'description',
					content: 'Duckist.com - Best Free Encrypted Messaging, Chat Room, Password & File Protection Service, with Self-Destruct feature. Secure sensitive data with link tracking web app and protect yourself from phishing.'
				}
			]
		},
		components: {
			Benefits,
			Button,
			ChatBenefits,
			Flash,
			ModalShowChat,
			Feedback,
			'v-select': vSelect,
			vueDropzone: vue2Dropzone,
		},
		props: ["messageId", "roomId"],
		data() {
			return {
				dropOptions: {
					url: "https://api.duckist.com/files/upload",
					maxFiles: 1,
					chunking: true,
					thumbnailWidth: 150, // px
					thumbnailHeight: 150,
					addRemoveLinks: true,
					autoProcessQueue: false
				},
				allCountries: [],
				allTimezones: [],
				contentType: 'inbox',
				showSideMenu: false,
				message_id: '',
				host: "",
				msg: "",
				encryptedMessage: "",
				msgUrl: "Encrypting...",
				encrypting: false,
				encrypting_message: "",
				decrypting_message: "",
				encryptKey: "",
				filePath: "",
				decryptedFilePath: "",
				checkedExpireDate: "1440",
				expiryDateOptions: [
					{
						id: 1,
						title: "day",
						value: 1440,
					},
					{
						id: 2,
						title: "week",
						value: 10080,
					},
					{
						id: 3,
						title: "month",
						value: 43200,
					},
				],

				objFile: null,

				validCreditCard: false,
				creditCardMsg: "Submit",
				afterGetFreeTrial: false,
				decryptedMessage: null,
				msgError: null,
				hash: "",
				loading: false,
				countDown: 5,
				logged_in: false,
				public_id: "",
				notifyModel: false,
				msgInfo: {
					note: "",
					logs: [],
					alert_when_opened_not_in: {},
				},
				paymentData: {
					country: "",
				},
				userData: {},
				userMessages: [],
				messageAction: "",
				newEncryptFile: {},
				btnClicked: false,
				validFileSize: false,
				validFileMsg: "",
				fileDownloaded: false,
				fileNotEncrypted: false,
				close_modal_encrypted: false,
				url_copied: false,
				currentChunck: null,
				totalChunkCount: null,
				fileDownloadStatus: "Download",

				message: "",
				author: "",
				allMessages: null,
				hashMissing: false,
				no_messages: false,
				message_expire: "",
				chat_url: "",
				show_copied_msg: false,
				timeOut: null,
				memo_saved: false,
				show_tooltip: false,
				hideDropzone: false,
				modalEncrypted: false,
				VIEW: {
					HOME: 'home',
					UPLOAD: 'upload',
					MESSAGE: 'message',
					ENCRYPT: 'encrypt',
					DECRYPTED: 'decrypted',
				},
				activeView: 'home',
				count: parseInt(localStorage.getItem('modalCount')) || 0,
				filehandle: false
			};
		},
		methods: {
			openShareLink() {
				this.$bvModal.show('modal-share-chat-link')
				this.chat_url = location.href
			},
			validSecurityCode() {
				let security_code = this.paymentData.security_code
				if (security_code.length < 3) {
					this.validCreditCard = false
					this.creditCardMsg = "Invalid Security Code"
				} else {
					this.validCreditCard = true
					this.creditCardMsg = "Start Free Trial"
				}
			},
			validExpiryDate() {
				let cleanDate = this.paymentData.expire_date.replaceAll(" ", "")
				let mounth = cleanDate.substring(0, cleanDate.indexOf("/"))
				let year = cleanDate.substring(cleanDate.indexOf("/") + 1)
				year = Number(year)

				let yearNow = new Date().getFullYear().toString().slice(-2)
				yearNow = Number(yearNow)

				if (cleanDate.length < 5) {
					this.validCreditCard = false
					this.creditCardMsg = "Invalid Expiry Date"
				} else if (year < yearNow) {
					this.validCreditCard = false
					this.creditCardMsg = "Year is less than current year"
				} else if (year > yearNow + 10) {
					this.validCreditCard = false
					this.creditCardMsg = "Incorrect expiration date"
				} else if (mounth > 12) {
					this.validCreditCard = false
					this.creditCardMsg = "Month should be between 01 and 12"
				} else {
					this.validCreditCard = true
					this.creditCardMsg = "Start Free Trial"
				}
			},
			validCardNumber(e) {
				if (!this.paymentData.credit_card_number) {
					this.creditCardMsg = "Start Free Trial"
				} else if (valid.number(e.target.value).isValid && this.paymentData.credit_card_number) {
					this.validCreditCard = true
					this.creditCardMsg = "Start Free Trial"
				} else {
					this.validCreditCard = false
					this.creditCardMsg = "Invalid Card Number"
				}
			},
			openLogs(messageId) {
				this.public_id = messageId
				this.$bvModal.show('modal-logs')
				this.msgInfo.logs = this.userMessages.filter(item => item.public_id == this.public_id)[0].logs
			},
			editAlerts(messageId) {
				this.public_id = messageId
				this.$bvModal.show('modal-edit-notification');
				this.allCountries = countryList.getData()
				this.msgInfo = {...this.userMessages.filter(item => item.public_id == this.public_id)[0]}
				let country_code = this.msgInfo.alert_when_opened_not_in
				this.msgInfo.alert_when_opened_not_in = this.allCountries.filter(item => item.code == country_code)[0] || "" // To show placeholder text instead of empty space
			},
			openSideMenu() {
				this.showSideMenu = !this.showSideMenu
				this.contentType = "inbox"
				this.getAllMsgs()
				this.getUserData()
				this.$nextTick(() => {
					this.$refs.side_menu.focus()
				})

				eventBus.$emit('openSideMenu', this.showSideMenu);
			},
			closeDashboard() {
				this.showSideMenu = false,
				eventBus.$emit('closeSideMenu', this.showSideMenu);
			},
			logOut() {
				eventBus.$emit('logOut');
				this.showSideMenu = false;
				this.logged_in = false;
				this.objFile = null;
				this.validFileSize = false;
				location.hash = "";
				localStorage.clear();
			},
			async upgradePlan() {
				try {
					let data = ""
					const response = await api.put(`/users/activate_pro`, data);
					if (response.data.status == 'ok') {
						this.$router.push("/payment-success")
					}
				} catch (e) {
					this.$router.push("/payment-failed")
					this.sendErrorToApi(e.response.data.msg)
					console.log(e)
				}
			},
			async editMessageInDashboard() {
				if (this.msgInfo.note.length > 64) {
					this.$refs.show.showFlashError("Name is too long!")
					return
				}
				this.$bvModal.hide('modal-edit-notification')
				try {
					let data = {
						public_id: this.public_id,
						note: this.msgInfo.note,
						alert_when_opened_not_in: this.msgInfo?.alert_when_opened_not_in?.code || "",
					}

					const response = await api.put(`/msgs/edit`, data);
					if (response.data.status == 'ok') {
						this.$refs.show.showFlashSuccess('Data saved');
						this.getAllMsgs()
					}


				} catch (e) {
					this.$refs.show.showFlashError(e.response.data.status)
					console.log(e)
				}
			},
			async editMessageMemo() {
				clearTimeout(this.timeOut);
				if (this.msgInfo.note.length > 64) {
					this.$refs.show.showFlashError("Name is too long!")
					return
				}
				this.timeOut = setTimeout(async () => {
					try {
						let data = {
							public_id: this.public_id,
							note: this.msgInfo.note,
						}
						const response = await api.put(`/msgs/edit`, data);
						if (response.data.status == 'ok') {
							this.memo_saved = true;
						}
						setTimeout(()=>{
							this.memo_saved = false;
						}, 2000)
					} catch (e) {
						this.$refs.show.showFlashError(e.response.data.status)
						console.log(e)
					}
				}, 2000)
			},
			async editMessage() {
				if(this.userData.plan === 'free'){
					return
				}
				try {
					let data = {
						public_id: this.public_id,
						alert_when_opened_not_in: this.msgInfo?.alert_when_opened_not_in?.code || "",
					}
					const response = await api.put(`/msgs/edit`, data);
					if (response.data.status == 'ok') {
						this.$refs.show.showFlashSuccess('Data saved');
					}
				} catch (e) {
					this.$refs.show.showFlashError(e.response.data.status)
					console.log(e)
				}
			},
			async getAllMsgs() {
				if (!localStorage.accessToken) {
					return
				}
				try {
					let data = ""
					const response = await api.put(`/msgs/all`, data);
					if (response.data.status == 'ok') {
						this.userMessages = response.data.msgs
					}
					if (response.data.msg == "Invalid access. Requires user") {
						this.logged_in = false
						localStorage.removeItem('accessToken')
						eventBus.$emit('logOut');
					}
				} catch (e) {
					this.$refs.show.showFlashError(e.response.data.msg)
					console.log(e)
				}
			},
			async saveUserData() {
				let data = {
					name: this.userData.name,
					address: this.userData.address,
					country: this.userData.country?.name || "",
					tin: this.userData.tin,
					timezone: this.userData.timezone?.label || "",
					city: this.userData.city,
					zipcode: this.userData.zipcode,
				};
				await api.put(`/users/edit`,
					data,
				).then(response => {
					if (response.data.status == 'ok') {
						this.$refs.show.showFlashSuccess('Data saved');
					}
				}).catch(e => this.$refs.show.showFlashError(e.response.data.msg))
			},
			async getUserData() {
				if (!localStorage.accessToken) {
					return
				}
				let data = {};
				await api.put(`/users/edit`, data).then(response => {
					if (response.data.status == 'ok') {
						this.userData = {...response.data.msg}
						console.log(this.userData);
						if (this.userData.plan == 'pro') {
							this.afterGetFreeTrial = true;
						}
						if (this.userData.timezone === "" && this.allTimezones.length) {
							let browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
							let filteredTimezone = this.allTimezones.filter(item => item?.label.includes(browserTimezone))?.[0]?.label
							this.userData.timezone = filteredTimezone
						}

					} else if (response.data.msg === "Invalid access. Requires user") {
						this.logged_in = false
						localStorage.removeItem('accessToken')
						console.log("accessToken removed")
						eventBus.$emit('logOut');
					} else {
						localStorage.clear()
					}
				}).catch(e => {
					console.log(e);
				})
			},
			formatDate(date) {
				if (!date) {
					return
				}
				let newDate = new Date(date);
				newDate = ('0' + (newDate.getMonth() + 1)).slice(-2) + '-' + ('0' + newDate.getDate()).slice(-2) + '-' + newDate.getFullYear();
				let hours = new Date(date).getHours()
				let min = new Date(date).getMinutes()
				if (min <= 9) {
					min = `0${min}`
				}
				return `${newDate} ${hours}:${min}`;
			},
			closeModalEncrypted() {
				this.close_modal_encrypted = true;
				this.$bvModal.hide('modal-confirm');
				this.$bvModal.hide('modal-encrypted')
			},
			countryCodeToName(country_code) {
				if (typeof country_code !== 'string') {
					return
				}
				const country = this.allCountries.filter(item => item.code == country_code)[0]
				if (typeof country === "object") {
					return country.name
				} else {
					return "Wrong country code"
				}
			},
			async deleteFile(file) {
				try {
					const response = await api.put(`/files/delete_by_id`, {id:file});

				} catch (e) {
					console.log(e);
				}
			},
			async sendErrorToApi(error) {
				try {
					let data = {
						error: error
					}
					let response = await api.put(`/feedback/log`, data)
				} catch (e) {
					console.log(e)
				}
			},
			async downloadFile() {
				try {
					let url = `${process.env.VUE_APP_MEDIA}${this.filePath}`
					const file = this.filePath
					this.fileDownloadStatus = 'Downloading...'
					let response = await axios.get(url, {responseType: "blob"});

					this.fileDownloadStatus = 'Decrypting...'

					await this.decryptFile(response.data)
						.then(response => {
							this.fileDownloadStatus = 'File Downloaded'
							this.deleteFile(file)
							this.fileDownloaded = true;
						})
						.catch(err => {
							console.error(err);
						});

				} catch (e) {
					this.fileDownloadStatus = 'Error happened'
					console.log(e.response.data.msg)
					this.sendErrorToApi(e.response.data.msg)
				}
			},
			generateEncryptKey(length) {
				let result = '';
				let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				let charactersLength = characters.length;
				for (let i = 0; i < length; i++) {
					result += characters.charAt(Math.floor(Math.random() *
						charactersLength));
				}
				return result;
			},
			async sendMessageData() {
				if (this.msg == "" && !this.objFile) {
					return
				}
				const hey_text = "Hey, this is a Duckist link. It will self-destruct after viewing. Make sure to copy it before closing it:\n"

				await this.getUserData();

				if (this.logged_in && this.userData.msgs_left === 0) {
					return;
				} else{
					this.activeView = this.VIEW.ENCRYPT;
				}

				this.encrypting = true;
				this.encryptKey = this.generateEncryptKey(32);
				this.msgInfo.alert_when_opened_not_in = ""; // To show placeholder text instead of empty space
				this.msgInfo.note = "";
				try {
					this.btnClicked = true;
					if (this.objFile && this.objFile.name) {
						this.encrypting_message = 'Encrypting your file…'

						await this.encryptFile().catch(err => {
							this.fileNotEncrypted = true
							console.log(err);
						});
					}
					if (this.msg) {
						this.encrypting_message = 'Encrypting your message…'
						this.encryptedMessage = sjcl.encrypt(this.encryptKey, this.msg);
					}

					let requestOptions = {
						body: this.encryptedMessage,
						expire: this.checkedExpireDate,
						filehandle: this.filePath,
					};
					const response = await api.put(`/msgs/new`, requestOptions);

					this.btnClicked = false;
					this.encrypting = false;
					let data = response.data.data;
					this.public_id = data.public_id;
					this.msgUrl = `${hey_text} ${this.host}/msgs/${data.public_id}#${this.encryptKey}`;
					this.filePath = "";

					// TODO
					// setTimeout(() => {
					// 	this.copyEncryptedMessageUrl("input")
					// }, 500)

				} catch (e) {
					this.encrypting = false
					this.url_copied = true // Do not show confirm modal

					this.$bvModal.hide('modal-encrypted')
					console.log(e.response.data);
					if (e.response.data.msg == "Invalid access. Requires user") {
						this.logged_in = false
						localStorage.removeItem('accessToken')
						console.log("accessToken removed")
						eventBus.$emit('logOut');
						this.$refs.show.showFlashWarning("Your session has expired or been cancelled, please log in again", 5000)
					} else {
						this.$refs.show.showFlashError(e.response.data.status)
					}

				}
			},
			async getMessage() {
				try {
					this.loading = true
					let url = ""
					if (location.hostname == 'localhost') {
						url = `/msgs/` + this.messageId + '?debug=true';
					} else {
						url = `/msgs/` + this.messageId + location.hash;
					}

					let response = await api.get(url);

					if (response.data.data) {
						this.filehandle = response.data.data?.filehandle ? true : false
						this.filePath = response.data.data?.filehandle?.path
						this.decryptedMessage = sjcl.decrypt(this.hash, response.data.data.body);
					} else {
						console.log(response.data.error);
						this.countDown = 0
					}
					this.loading = false

				} catch (e) {
					console.log(e);
					this.loading = false
					this.sendErrorToApi(e.response?.data.msg)
				}
			},
			copyEncryptedMessageUrl(element) {
				this.url_copied = true;
				let copyText = this.$refs[element];
				copyText.select();
				document.execCommand("copy");
				this.show_copied_msg = true;
				this.openModal();

				setTimeout(() => {
					this.show_copied_msg = false
				}, 2000)
			},
			openModal() {
				this.count++;
				
				if (this.count % 4 === 0) {
					this.$bvModal.show('modal-encrypted');
				}

				localStorage.setItem('modalCount', this.count);
			},
			copy(element) {
				// copy chat Url, decrypted message
				let copyText = this.$refs[element];
				copyText.select();
				document.execCommand("copy");
				this.$refs.show.showFlashSuccess('Copied');
			},
			countDownTimer() {
				if (this.countDown > 0) {
					setTimeout(() => {
						this.countDown -= 1
						this.countDownTimer()
					}, 1000)
				} else this.countDown = 0
			},
			actionAfterClose() {
				this.msgInfo.alert_when_opened_not_in = {}
				this.msgInfo.note = "";
				this.url_copied = false;
				this.close_modal_encrypted = false;
				this.objFile = null;
			},
			actionBeforeClose(e) {
				if (!this.close_modal_encrypted && !this.url_copied) {
					e.preventDefault();
					this.$bvModal.show("modal-confirm")
				} else this.$bvModal.hide("modal-encrypted")
			},
			handleOpenDashboard(data) {
				this.showSideMenu = data
				if (this.showSideMenu) {
					this.contentType = "inbox"
					this.getAllMsgs()
					this.getUserData()
					this.$nextTick(() => {
						this.$refs.side_menu.focus()
					})
				} else {
					location.hash = ""
				}
			},
			readfile(file) {
				return new Promise((resolve, reject) => {
					let fr = new FileReader();
					fr.onload = () => {
						resolve(fr.result)
					};
					fr.readAsArrayBuffer(file);
				});
			},
			removefile() {
				this.objFile = null;
			},
			selectfile(event) {
				this.objFile = event;

				if (!this.objFile || (this.objFile && !this.objFile.name)) {
					return;
				}

				if (this.objFile && this.objFile.name) {
					this.hideDropzone = true;
				}

				if (this.objFile && this.logged_in && this.userData.msgs_left == 0) {
					this.validFileSize = true
					this.validFileMsg = "You have no more uploads available. Upgrade your plan or wait up to 24 hours."
					return;
				}

				if (!this.logged_in && this.objFile?.size > 1024 * 1024 * 3) {
					this.validFileSize = true;
					this.validFileMsg = "You can encrypt up to 3 MB files. Please log in to encrypt bigger files.";
				}
				else if (this.logged_in && this.userData?.plan === "free" && this.objFile?.size > 1024 * 1024 * 5) {
					this.validFileSize = true;
					this.validFileMsg = "You can encrypt up to 5 MB files. Upgrade your plan to increase file size.";
				}
				else if (this.logged_in && this.objFile?.size > 1024 * 1024 * 100) {
					this.validFileSize = true;
					this.validFileMsg = "You can encrypt up to 100 MB files. Upgrade your plan to increase file size.";
				}
				else {
					this.validFileSize = false;
				}
			},
			async encryptFile() {
				if (!this.objFile) {
					return
				}
				const chunkSize = 1000000 // 1mb

				this.totalChunkCount = Math.ceil(this.objFile.size / chunkSize)

				let fileName = await this.generateEncryptKey(8)
				let plainTextBytes = await this.readfile(this.objFile)

				let getFileName = this.objFile.name.substring(0, this.objFile.name.indexOf('.'));
				let getFileType = this.objFile.name.substring(this.objFile.name.indexOf('.'));

				plainTextBytes = new Uint8Array(plainTextBytes);
				let keybytes = new TextEncoder("utf-8").encode(this.encryptKey);
				let ivbytes = keybytes.slice(0, 16); // initialization vector

				let formData = new FormData();
				let pbkdf2salt = window.crypto.getRandomValues(new Uint8Array(8));

				// Chunking file -> encrypt chunk -> send chunk

				for (let i = 0; i < this.totalChunkCount; i++) {
					this.currentChunck = i
					let offset = i * chunkSize;
					let fileChunk = plainTextBytes.slice(offset, offset + chunkSize)

					// Generate enc key
					let key = await window.crypto.subtle.importKey('raw', keybytes, {
						name: 'AES-CBC',
						length: 256
					}, false, ['encrypt'])

					// Encrypt
					let cipherBytes = await window.crypto.subtle.encrypt({
						name: "AES-CBC",
						iv: ivbytes
					}, key, fileChunk)

					cipherBytes = new Uint8Array(cipherBytes);

					let cipherBytesLength = new TextEncoder("utf-8").encode(cipherBytes.length)

					let resultBytes = new Uint8Array(cipherBytes.length + 32)

					let salt = new TextEncoder("utf-8").encode('Salted__')

					// 8 ->  "Salted__" key word
					// 8 ->  Salt key
					// 16 -> Encrypted chunk length
					// if original file chunk = 1_000_000 (1mb), encryped =  1_000_016 (formula: cipherLen = (clearLen/16 + 1) * 16)

					resultBytes.set(salt);
					resultBytes.set(pbkdf2salt, 8);
					resultBytes.set(cipherBytesLength, 16);
					resultBytes.set(cipherBytes, 32);

					let blob = new Blob([resultBytes], {type: 'application/download'});
					let newFile = new File([blob], fileName + '.enc', {type: "application/download"})

					formData.set('file', newFile);
					formData.set('dzuuid', getFileName + getFileType.trim());
					formData.set('dzchunkindex', i);
					formData.set('dztotalfilesize', chunkSize);
					formData.set('dztotalchunkcount', this.totalChunkCount);
					formData.set('dzchunkbyteoffset', chunkSize);

					try {
						const response = await api.post(`/files/upload`, formData);

						if (response.data.status == 'ok') {
							this.filePath = response.data.msg.path
							this.delete_file_after_uploading = response.data.msg.path
						}
					} catch (e) {
						this.$refs.show.showFlashError(e.response.data.msg);
						this.encrypting = false;
						this.sendErrorToApi(e.response.data.msg)
					}
				}
			},

			async decryptFile(file) {
				const chunkSizeFile = 1000000 // 1mb

				let cipherBytes = await this.readfile(file)
				cipherBytes = new Uint8Array(cipherBytes);
				let textDecoder = new TextDecoder("utf-8");

				let keybytes = new TextEncoder("utf-8").encode(this.hash);
				let ivbytes = keybytes.slice(0, 16);
				let pbkdf2salt = cipherBytes.slice(8, 16);

				let chunkSize = parseInt(textDecoder.decode(cipherBytes.slice(16, 32))); // read first chunk length
				const totalChunkCount = Math.ceil(file.size / chunkSize)

				let blob = new Blob([], {type: 'application/download'});

				for (let i = 0; i < totalChunkCount; i++) {
					let offset = (i * chunkSize) + 32 + (32 * i);
					if (i > 0) {
						chunkSize = parseInt(textDecoder.decode(cipherBytes.slice(chunkSize + 32 * 2 - 16, chunkSize + 32 * 2)));
					}
					let fileChunk = cipherBytes.slice(offset, offset + chunkSize)
					// (32, 1_000_048) - first chunk data (start, end)
					// (1_000_080, 2_000_096) - second chunk data (start, end)

					// Generate decrypt key
					let key = await window.crypto.subtle.importKey('raw', keybytes, {
						name: 'AES-CBC',
						length: 256
					}, false, ['decrypt'])

					// Decrypt
					let plainTextBytes = await window.crypto.subtle.decrypt({
						name: "AES-CBC",
						iv: ivbytes
					}, key, fileChunk).catch(err => {
						console.log(err);
					})

					plainTextBytes = new Uint8Array(plainTextBytes);
					blob = new Blob([blob, plainTextBytes], {type: 'application/download'});

				}

				// Dowload file
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);

				if (this.filePath.startsWith('/')) {
					this.filePath = this.filePath.substring(10) // 1 - "/", 8 - id, 10 - "-"
				} else this.filePath
				if (this.filePath.endsWith('.enc')) {
					this.filePath = this.filePath.slice(0, -4)
				} else this.filePath

				link.download = `${this.filePath}`;
				link.click();
			},
			async getMessages() {
				if (!this.roomId) {
					return
				}

				try {
					let data = {
						chatroom: this.roomId,
						attrs: ["pid", "author", "text", "masked_ip", "country", "chatroom", "created"]
					}

					function decrypt(key, value) {
						try {
							return sjcl.decrypt(key, value)
						} catch (e) {
							return null
						}

					}

					const response = await api.post(`/chats/all_msgs`, data);

					if (response.data.status == 'ok') {
						this.message_expire = response.data['chatroom.expire_msgs']
						this.allMessages = response.data.msgs

						if (!this.allMessages.length) this.no_messages = true

						this.allMessages = this.allMessages.map((item, index) => ({
							...item,
							text: decrypt(this.hash, item.text) ?? "error"
						}));

					}
				} catch (e) {
					console.log(e)
				}
			},
			async sendMessage() {
				try {

					this.encryptedMessage = sjcl.encrypt(this.hash, this.message);
					localStorage.setItem('chatName', this.author || "No name")

					let data = {
						author: this.author || "No name",
						text: this.encryptedMessage,
						chatroom: this.roomId,
						attrs: ["pid", "author", "text", "masked_ip", "country", "chatroom"]
					}

					const response = await api.post(`/chats/new_msg`, data);

					if (response.data.status == 'ok') {
						this.no_messages = false
						this.message = ""
						setTimeout(() => {
							const el = this.$refs.chat_messages;
							el.scrollTop = el.scrollHeight
						}, 2000)

					}
				} catch (e) {
					console.log(e)
				}
			},
			payPro(){
				// window.location.href = "https://buy.stripe.com/test_3cs6qmdTz1XEdZ6144?prefilled_email=insert%40email.com&client_reference_id=insert_client_id"
				window.location.href = `${process.env.VUE_APP_PRO_LINK}?prefilled_email=${this.userData.email}&client_reference_id=${this.userData.client_id}`
			},
			setActiveView(view) {
				this.activeView = view;

				if (view === this.VIEW.HOME) {
					this.msg = ''; // clear "message" textarea
					this.objFile = null; // clear "uploud file"
					this.hideDropzone = false;
				}

				if (view !== this.VIEW.ENCRYPT) {
					this.fileNotEncrypted = false;
				}
			},
			setFocusOnTextarea() {
				if (this.$refs.msg) {
					this.$refs.msg.focus();
				}
			},
		},
		watch: {
			activeView(newView) {
				if (newView === this.VIEW.MESSAGE) {
					this.$nextTick(() => {
						setTimeout(() => {
							this.setFocusOnTextarea();
						}, 100);
					});
				}
    	},
		},
		mounted() {
			// this.$bvModal.show("modal-encrypted")

			this.host = location.origin

			if(this.$route.query.chat === "true"){
				this.$bvModal.show('modal-show-chat')
			}

			if(this.$route.query.login === "true"){
				this.$bvModal.show('modal-login')
			}

			if (this.messageId) {
				console.log('msg:', this.decrypting_message)
				this.countDownTimer();

				this.activeView = this.VIEW.DECRYPTED;
				this.hash = location.hash.replace("#", "");
				//setTimeout(() => {
					this.getMessage();
				//}, 5000)
			}

			if (localStorage.accessToken) {
				this.logged_in = true
				this.getUserData()
				this.allTimezones = timezones
				this.allCountries = countryList.getData()
				if (!this.allCountries.some(country => country.name === "Kosovo")) {
					this.allCountries.push({ name: "Kosovo", code: "XK" });
				}
				this.getAllMsgs()
			}

			if (this.$route.name == 'Chat') {
				setInterval(() => {
					this.getMessages()
				}, 2000)

				this.chat_url = location.href
				this.author = localStorage.chatName || ""
				this.host = location.origin

				this.hash = location.hash.replace("#", "");
				if (!this.hash) this.hashMissing = true
			}

			eventBus.$on('openDashboard', this.handleOpenDashboard);
			eventBus.$on('update-active-view', this.setActiveView);
		},
		computed: {
			init() {
				// set default active view
				this.activeView = this.VIEW.HOME;
				
			},
			loadingBar() {
				return Math.floor((this.currentChunck + 1) * 100 / this.totalChunkCount)
			},
		},
		destroyed() {
			eventBus.$off('openDashboard', this.closeDashboard);
			eventBus.$off('update-active-view', this.setActiveView);
		}
	};
</script>

<style scoped lang="scss">
	@import "../assets/scss/modals/modal-payment"; // TODO remove???
	@import "../assets/scss/message-form.scss";
	@import "../assets/scss/encrypting.scss";
	@import "../assets/scss/benefits.scss";
	@import "../assets/scss/side-menu.scss";
	@import "../assets/scss/menu-settings.scss";
	@import "../assets/scss/modals/modal-logs.scss";
	@import "../assets/scss/modals/modal-upgrade-plan.scss";
	@import "../assets/scss/modals/modal-confirm.scss";
	@import "../assets/scss/modals/modal-share-chat-link.scss";
	@import "../assets/scss/modals/modal-encrypted";
	@import "../assets/scss/modals/modal-dencrypted";
	@import "../assets/scss/chat.scss";

	.btn-copy-url {
		width: 100%;
		padding: 9px 25px;
		@include btn-orange();
		margin-bottom: 30px;
	}

	.message-url-input {
		background: #f6f6f6;
		color: #6C6C74;
		padding: 12px 15px;
		border: 1px solid #E5E5E5;
		border-radius: 2px;
		max-height: 160px;
		resize: none;
		font-size: 14px;

		&:focus {
			border-color: #E5E5E5;
			box-shadow: none;
			outline: unset;
			background: #f6f6f6;
		}
	}

	.form-check {
		padding-left: 0;
	}

	.show-alerts {
		font-weight: 600;
		font-size: 14px;
		line-height: 24px;
		text-align: center;
		letter-spacing: -0.02em;
		text-transform: capitalize;
		color: #63BAAB;
		text-decoration: none;
		text-align: center;
	}

	.vue-dropzone {
		padding: 0;
		border: none;
	}

	.img-wrap {
		text-align: center;
	}

	.notifications-checkboxes {
		.form-check {
			padding-left: 0;
		}

		.custom-checkbox {
			position: absolute;
			opacity: 0;

			& + label {
				position: relative;
				cursor: pointer;
				padding: 0;
				width: 100%;
				background: #3E4755;
				border-radius: 6px;
				padding: 16px;
				font-size: 14px;
				line-height: 22px;
				letter-spacing: -0.02em;
				color: #FFFFFF;
				display: flex;
				align-items: center;
			}

			& + label:before {
				content: '';
				margin-right: 10px;
				display: inline-block;
				vertical-align: text-top;
				width: 20px;
				height: 20px;
				background: white;
				border-radius: 4px;
			}

			&:checked + label:before {
				background: #FF7A00;
			}

			&:checked + label:after {
				content: '';
				position: absolute;
				left: 21px;
				top: 27px;
				background: white;
				width: 2px;
				height: 2px;
				box-shadow: 2px 0 0 white,
				4px 0 0 white,
				4px -2px 0 white,
				4px -4px 0 white,
				4px -6px 0 white,
				4px -8px 0 white;
				transform: rotate(45deg);
			}
		}
	}

	.btn-save-msg-changes {
		@include btn-orange;
		width: 100%;
	}

	.btn-show-advanced {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 50%);
		background: #fff;
		box-shadow: 0px 4px 8px rgba(52, 52, 52, 0.25);
		border-radius: 50%;
		height: 54px;
		width: 54px;
		line-height: 1;
		font-size: 8px;
		border: 0;

		&:focus {
			outline: none;
			box-shadow: unset;
		}
	}

	::v-deep #drop1 {
		min-height: auto;
		margin-bottom: 21px;
		z-index: 1;

		.dz-message {
			margin: 0;
			display: flex;
			justify-content: center;
		}

		.dz-preview {
			display: none;
		}
	}

	::v-deep .dropzone .dz-preview .dz-error-message {
		top: 0;
	}

	.loading-bar {
		text-align: center;
		background: #ff7a00;
		border-radius: 25px;
		color: #21405B;
		position: absolute;
		top: 1px;
		left: 1px;
		z-index: 2;
		height: 8px;
	}

	.loading-bar-text {
		font-weight: 700;
		font-size: 16px;
		line-height: 20px;
		text-align: right;
		letter-spacing: -0.02em;
		color: #ffffff;
	}

	.loading-bar-border {
		height: 10px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		border-radius: 100px;
	}

	.encrypting-message-duck {
		min-height: 256px;
	}

	.no-messages-left {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 3;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		backdrop-filter: blur(3px);
		padding: 25px;
		display: flex;
		flex-direction: column;
	}

	.you-out-of-messages {
		font-weight: 600;
		font-size: 18px;
		line-height: 26px;
		letter-spacing: -0.02em;
		max-width: 441px;
		margin: 20px auto;
	}
	.uploaded-file-name {
		color: #FA852E;
	}
	.remove-file{
		border: 0;
		font-weight: 600;
		color: #ffffff;
		background-color: inherit;
	}
</style>
